var map = {
	"./computer-screen.svg": 532,
	"./facebook-icon.svg": 533,
	"./google-plus-icon.svg": 534,
	"./icon-2.svg": 535,
	"./icon-3.svg": 536,
	"./icon-4.svg": 537,
	"./icon-5.svg": 538,
	"./icon-6.svg": 539,
	"./icon-7.svg": 540,
	"./icon-8.svg": 541,
	"./icon.svg": 542,
	"./ig-icon.svg": 543,
	"./invisalign_logo.svg": 544,
	"./logo-white.svg": 545,
	"./logo.svg": 546,
	"./twitter-icon.svg": 547,
	"./youtube-icon.svg": 548
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 620;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = 620
// module chunks = 1